/* Copyright (c) 2022 Xperi. All Rights Reserved. */

/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
export enum MediaButtonTypes {
    // Start From Buffer, Start Over and Start over share same index
    /* 0 */ START_FROM_BUFFER_BUTTON_INDEX,
    /* 1 */ REPLAY_BUTTON_INDEX,
    /* 2 */ REWIND_BUTTON_INDEX,
    /* 3 */ PLAY_PAUSE_BUTTON_INDEX,
    /* 4 */ FORWARD_BUTTON_INDEX,
    /* 5 */ ADVANCE_BUTTON_INDEX,
    /* 6 */ GO_TO_LIVETV_BUTTON_INDEX,
    /* 7 */ LIVE_BUTTON_INDEX,
    /* 8 */ INFO_BUTTON_INDEX,
}

export type MediaButtonState = {
    type: MediaButtonTypes;
    isActive: boolean;
    isFocus: boolean;
};
